import axios from 'axios';

const updatePrevisaoEntregaProduto = (id, idProduto, data) => axios.put(`/compras/${id}/produtos/${idProduto}/previsao-entrega`, data);
const finalizarEntregaProduto = (id, idProduto) => axios.put(`/compras/${id}/produtos/${idProduto}/entregas`, {});
const cancelarItemCompraProduto = (idItemCompraProduto, data) => axios.put(`/compras/produtos/${idItemCompraProduto}/cancelar`, data);

export default {
  updatePrevisaoEntregaProduto,
  finalizarEntregaProduto,
  cancelarItemCompraProduto,
};
